require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/analytics/legacy/framework/anly-shopping-tool.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/analytics/legacy/framework/anly-shopping-tool.legacy.js
// module id = 765
// module chunks = 31